export function useCategoryProductnature(initialValue: string | null = null) {
	return useState<string | null>('category-productnature', () => initialValue);
}
